import { render, staticRenderFns } from "./Spintax.vue?vue&type=template&id=b1ec0326&"
import script from "./Spintax.vue?vue&type=script&lang=js&"
export * from "./Spintax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports